import z from 'zod';

export const stepVideoSchema = z
  .object({
    id: z.string(),
    type: z.enum(['VIDEO']),
    // Uno dei due (videoId, audioId) deve essere sempre presente
    videoId: z.string().optional(),
    audioId: z.string().optional(),
    order: z.number().optional(),
  })
  .refine(data => !!data.videoId || !!data.audioId, {
    message: 'Deve essere selezionato almeno un video o un audio.',
  });

export const stepQuestionSchema = z.object({
  id: z.string(),
  type: z.enum(['QUESTION']),
  name: z.string().optional(),
  text: z.string().min(1, { message: 'Il testo della domanda è obbligatorio' }),
  answers: z
    .array(
      z.object({
        id: z.string(),
        label: z
          .string()
          .min(1, { message: 'Il testo della risposta è obbligatoria' }),
        goToStepId: z
          .string()
          .min(1, {
            message:
              "Crea prima uno step successivo o seleziona 'Fine Esperienza'",
          })
          .refine(val => val !== undefined, {
            message:
              "Crea prima uno step successivo o seleziona 'Fine Esperienza'",
          }),
      })
    )
    .min(2, { message: 'È necessario aggiungere almeno due risposte' }),
  order: z.number().optional(),
});
export const sessionConfigSchema = z.object({
  id: z.string().optional(),
  name: z.string().optional(),
  description: z.string().optional(),
  returnToWaitingRoom: z.boolean().optional(),
  steps: z
    .array(z.union([stepQuestionSchema, stepVideoSchema]))
    .min(1, { message: 'È necessario aggiungere almeno uno step' }),
});
